import React from "react";
import { Routes, Route } from "react-router-dom";

import BuyerDashboard from "../pages/buyer/BuyerDashboard";

const BuyerRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<BuyerDashboard />} />
    </Routes>
  );
};

export default BuyerRoutes;